(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bm-product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bm-product-card')) {
  customElements.define('bm-product-card', class BmProductCard extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('.bm-card__add');
      this.error = this.querySelector('.bm-card__error');
      this.planInput = this.querySelector('.bm-card__plan-input');
      this.opts = Array.prototype.slice.call(this.querySelectorAll('.bm-card__opt'));

      this.opts.forEach((opt, i) => {
        opt.addEventListener('click', () => this.setPlan(opt.dataset.value));
        opt.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          const next = this.opts[(i + 1) % this.opts.length];
          this.setPlan(next.dataset.value);
          next.focus();
        });
      });
      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    setPlan(value) {
      this.dataset.plan = value;
      this.opts.forEach((o) => {
        const on = o.dataset.value === value;
        o.setAttribute('aria-checked', on ? 'true' : 'false');
        o.tabIndex = on ? 0 : -1;
      });
      /* one-time = no selling_plan sent; subscription = the plan id */
      if (this.planInput) this.planInput.disabled = value !== 'subscription';
    }

    getCart() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    showError(msg) {
      if (!this.error) return;
      this.error.textContent = msg || '';
      this.error.hidden = !msg;
    }

    onSubmit(evt) {
      evt.preventDefault();
      if (this.button.disabled || this.button.classList.contains('is-loading')) return;
      this.showError('');
      this.button.classList.add('is-loading');
      this.button.setAttribute('aria-disabled', 'true');

      const cart = this.getCart();
      const formData = new FormData(this.form);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map((s) => s.id));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      const url = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(url, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: formData,
      })
        .then((r) => r.json())
        .then((response) => {
          if (response.status) {
            this.showError(response.description || response.message || this.dataset.error || 'Could not add to cart.');
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartError, { source: 'bm-product-card', productVariantId: formData.get('id'), errors: response.errors || response.description, message: response.message });
            }
            return;
          }
          if (!cart || typeof cart.renderContents !== 'function') {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bm-product-card', productVariantId: formData.get('id'), cartData: response });
          }
          cart.renderContents(response);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        })
        .catch((e) => {
          console.error(e);
          this.showError(this.dataset.errorNetwork || 'Network error, please try again.');
        })
        .finally(() => {
          this.button.classList.remove('is-loading');
          this.button.removeAttribute('aria-disabled');
        });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
